import { render, staticRenderFns } from "./position-view-page.vue?vue&type=template&id=3452b76a&"
import script from "./position-view-page.vue?vue&type=script&lang=js&"
export * from "./position-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports